import { cva, type VariantProps } from "cva";

export const bannerStyles = cva({
  base: [
    "group relative w-full flex items-center justify-center gap-x-10 p-8 md:p-4 text-body-4 border-b-1 transition-colors duration-250 ease-out-quad",
  ],
  variants: {
    variant: {
      default:
        "bg-surface-1 text-content-primary border-b-1 border-ink-100 hover:bg-purple-100 active:bg-purple-100 hover:border-purple-300 active:border-purple-300",
      filled: "bg-content-accent text-white hover:bg-purple-700 active:bg-purple-700",
      black: "bg-ink-700 text-white hover:bg-black active:bg-black",
    },
    closeable: {
      true: "p-8 md:p-4",
      false: "p-8 md:py-11",
    },
  },
});

export const bannerIconStyles = cva({
  base: "w-16 h-16 flex items-center justify-center [&>svg]:w-auto [&>svg]:h-12 [&>svg]:fill-current translate-x-0 group-hover:translate-x-2 transition-transform duration-350 ease-out-quart will-change-transform",
});

export type BannerStylesProps = VariantProps<typeof bannerStyles>;
